import { render, staticRenderFns } from "./LargeCard.vue?vue&type=template&id=10f22528&"
import script from "./LargeCard.vue?vue&type=script&lang=js&"
export * from "./LargeCard.vue?vue&type=script&lang=js&"
import style0 from "./LargeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports